import type { RefObject } from "react";
import { invariant } from "@searchui-searchforms/shared/utils";
import { useOnRemoveField } from "@/features/form-fields";
import type { FieldPath, FormAPI } from "@/shared/forms";
import type { FormValues, SubmitMeta } from "../form";

interface UseOnRemoveFieldHandlerArgs {
    formRef: RefObject<FormAPI<FormValues, SubmitMeta> | null>;
}

/** Removes the same index from the primary entry and every coupled entry, so a mixed row never leaves one entry orphaned. */
export const useOnRemoveFieldHandler = ({ formRef }: UseOnRemoveFieldHandlerArgs) => {
    useOnRemoveField(({ fieldName, coupledFieldNames = [], index }) => {
        const formApi = formRef.current;
        invariant(formApi, "Form ref is not initialized");
        for (const path of [fieldName, ...coupledFieldNames]) {
            formApi.removeArrayItem(path as FieldPath<FormValues>, index);
        }
    });
};
